import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { UPDATE_ENERGY_TRADING_MUTATION } from "../../graphql/mutations/updateEnergyTrading";
import Button from "../Button/Button";

const UpdateEnergyTrading = ({ onClose, selectedData, onApply }) => {
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      energyTrading: selectedData.energyTrading || false,
    },
  });

  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    setCurrentData(selectedData);
    setValue("energyTrading", selectedData.energyTradingEnabled);
  }, [selectedData, setValue]);

  const [updateEnergyTrading, { loading, error }] = useMutation(
    UPDATE_ENERGY_TRADING_MUTATION
  );

  const handleFormSubmit = async (data) => {
    try {
      const response = await updateEnergyTrading({
        variables: {
          id: parseInt(currentData.id, 10),
          energyTradingEnabled: data.energyTrading,
        },
      });

      if (response.data.updateClientEnergyTrading.client) {
        onApply();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Energy Trading</h3>
      </div>
      <div className="basic-modal__body">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="radio-group">
            <Controller
              name="energyTrading"
              control={control}
              render={({ field }) => (
                <div className="radio-group__container radio-group__container--vertical">
                  <div className="switch-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        className="switch__input"
                        checked={field.value}
                        onChange={() => {
                          field.onChange(!field.value);
                        }}
                      />
                      <span className="switch__slider"></span>
                    </label>
                    <div className="switch-labels">
                      <span className="switch-labels__on">
                        Energy Trading OFF
                      </span>
                      <span className="switch-labels__off">
                        Energy Trading ON
                      </span>
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
          {error && <div className="form-error">Error: {error.message}</div>}
          <div className="basic-modal__footer">
            <Button
              type="button"
              onClick={onClose}
              className="button--secondary"
              name="Cancel"
              disabled={loading}
            />
            <Button
              type="submit"
              className="button--primary"
              name={loading ? "Applying..." : "Apply"}
              loading={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateEnergyTrading;
